export default "__VITE_ASSET__2d0cba5f__"